// extracted by mini-css-extract-plugin
export default {"red":"red--l2yWI","container":"container--o5Xh3","beginCell":"beginCell--fwf6D","endCell":"endCell--l7cSI","table":"table--Hs5TV"};